/**
 * Centralized API Configuration
 * Single source of truth for all backend endpoints
 */

// Environment detection
const ENV = process.env.NODE_ENV || 'development';

// API Endpoints by environment
const API_ENDPOINTS = {
  development: {
    AGENTCORE_URL: process.env.REACT_APP_AGENTCORE_URL || 'http://localhost:5000/api',
    LAMBDA_URL: process.env.REACT_APP_LAMBDA_URL || 'http://localhost:5001',
    SSO_URL: process.env.REACT_APP_SSO_URL || 'http://localhost:3000/sso',
  },
  production: {
    AGENTCORE_URL: process.env.REACT_APP_AGENTCORE_URL || 'https://agentcore.subs-cp-dev.com/api',
    LAMBDA_URL: process.env.REACT_APP_LAMBDA_URL || 'https://api-swt.subs-cp-dev.com',
    SSO_URL: process.env.REACT_APP_SSO_URL || 'https://sso.subs-cp-dev.com',
  },
};

// Get current environment config
const config = API_ENDPOINTS[ENV] || API_ENDPOINTS.development;

// Export main configuration
export const API_CONFIG = {
  AGENTCORE_URL: config.AGENTCORE_URL,
  LAMBDA_URL: config.LAMBDA_URL,
  SSO_URL: config.SSO_URL,
  // IAS Auth/User-Management service (deployed separately)
  IAS_BASE_URL: process.env.REACT_APP_IAS_BASE_URL || 'https://api.aurora.subs-cp-dev.com',
  TIMEOUT: 300000, // 5 minutes for long-running operations
  HEADERS: {
    'Content-Type': 'application/json',
  },
};

// Helper functions
export const getAgentCoreURL = () => API_CONFIG.AGENTCORE_URL;
export const getLambdaURL = () => API_CONFIG.LAMBDA_URL;
export const getSSOURL = () => API_CONFIG.SSO_URL;
export const getIASBaseURL = () => API_CONFIG.IAS_BASE_URL;

export default API_CONFIG;
